var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      { staticClass: "invoices-table show-on-print", class: _vm.classObj },
      [
        _c("caption", { staticClass: "invoices-table__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _vm.list.length
          ? [
              _c("thead", [
                _c(
                  "tr",
                  { staticClass: "no-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _vm.inModal
                      ? [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _vm._m(6),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.list, function (e, i) {
                  return _c(
                    "tr",
                    { key: i },
                    [
                      _c("td", { staticClass: "grey-cell" }, [
                        _vm._v(_vm._s(i + 1)),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(e.number ? e.number : "-"))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            e.date_resolution
                              ? _vm.dateParser(e.date_resolution)
                              : "-"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(e.bank_name ? e.bank_name : "-")),
                      ]),
                      _vm._v(" "),
                      _vm.inModal
                        ? [
                            _c("td", [_vm._v(_vm._s(e.bik ? e.bik : "-"))]),
                            _vm._v(" "),
                            e.code_ifns
                              ? _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ifns-title",
                                      attrs: { title: e.inspection_name },
                                    },
                                    [_vm._v(_vm._s(e.code_ifns))]
                                  ),
                                ])
                              : _c("td", [_vm._v("-")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("parseToTimeDate")(
                                    e.date_post ? e.date_post : "-"
                                  )
                                )
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.list.length && !_vm.archived
          ? _c("tr", { staticClass: "no-hover empty-invoices" }, [
              _c("td", [_vm._v("Решения отсутствуют")]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("№ п/п")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("№ решения")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("Дата")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("Название банка")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("БИК банка, в который направлено решение")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [_c("b", [_vm._v("Код налогового органа")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("b", [_vm._v("Дата и время размещения информации в сервисе ФНС")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }